import { useTranslation } from "react-i18next";
import { ShieldOff } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface AccessRestrictedProps {
  feature?: string;
}

export function AccessRestricted({ feature }: AccessRestrictedProps) {
  const { t } = useTranslation("common");
  return (
    <div className="p-4 md:p-6">
      <Card className="max-w-lg mx-auto mt-12">
        <CardContent className="py-16 text-center">
          <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
            <ShieldOff className="w-7 h-7 text-muted-foreground" />
          </div>
          <h3 className="font-semibold text-lg mb-1" data-testid="text-access-restricted-title">
            {t("accessRestricted.title")}
          </h3>
          <p className="text-sm text-muted-foreground max-w-xs mx-auto" data-testid="text-access-restricted-description">
            {feature
              ? t("accessRestricted.noPermissionFeature", { feature })
              : t("accessRestricted.noPermissionSection")}
            {" "}{t("accessRestricted.contactOwner")}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
